
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '@/utils/siteTracking';

/**
 * Component that automatically tracks page views when the route changes.
 * This component should be placed once in the app's component tree.
 */
export const PageViewTracker: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Record the page view when the pathname changes
    recordPageView(location.pathname);
  }, [location.pathname]);
  
  // This component doesn't render anything
  return null;
};

export default PageViewTracker;
